import React, { PureComponent, Fragment } from 'react'
import { Link, Redirect, Switch, Route } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import { GlobalFooter, Icon } from 'wbap-components'
import styles from './index.less'
import { getRoutes } from 'wbap-utils'
import { loadApp } from 'wbap-core-commit'

const links = [
  {
    key: 'home',
    title: '官网',
    href: 'http://www.kingmiles.cn/',
  },
  {
    key: 'gold',
    title: '金价看板',
    href: '',
  }
]

const copyright = (
  <Fragment>
    Copyright <Icon type="copyright"/> 2018 上海金迈网络科技有限公司
  </Fragment>
)

class UserLayout extends PureComponent {
  constructor (props) {
    super(props)
  }

  getPageTitle () {
    let title = '金迈WBAP应用平台'
    return title
  }

  render () {
    return (
      <DocumentTitle title={this.getPageTitle()}>
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.top}>
              <div className={styles.header}>
                <Link to="/">
                  <span className={styles.title}>WBAP应用管理平台</span>
                </Link>
              </div>
              <div className={styles.desc}>WBAP智慧门店系统,珠宝行业领先的新零售解决方案</div>
            </div>
            <Switch>
              <Route exact path='/user/wbap-admin-login' component={() => loadApp('wbap-admin-login')}/>
              <Redirect exact from="/user" to="/user/wbap-admin-login"/>
            </Switch>
          </div>
          <GlobalFooter links={links} copyright={copyright}/>
        </div>
      </DocumentTitle>
    )
  }
}

export default UserLayout



// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-root/components/UserLayout/index.js